module.exports = __webpack_public_path__ + "static/media/reveal.d88a8997.png";